"use client";

import { c as _c } from "react/compiler-runtime";
import { PERSONA_COOKIE_NAME, PERSONA_RELATED_DEFAULT_COOKIE_SETTINGS, PERSONAS, usePersona, useRouter } from "@opensea/navigation";
import Cookies from "js-cookie";
import { LONG_LASTING_COOKIE_EXPIRATION } from "@/lib/cookie";
import { trackAction } from "@/lib/integrations/datadog";
export function usePersonaSwitch() {
  const $ = _c(10);
  const {
    persona,
    setPersona
  } = usePersona();
  const router = useRouter();
  let t0;
  if ($[0] !== router || $[1] !== setPersona) {
    t0 = function setPersistedPersona(nextPersona) {
      trackAction("switch persona", {
        value: nextPersona
      });
      Cookies.set(PERSONA_COOKIE_NAME, nextPersona, {
        expires: LONG_LASTING_COOKIE_EXPIRATION
      });
      Object.entries(PERSONA_RELATED_DEFAULT_COOKIE_SETTINGS).forEach(t1 => {
        const [cookieName, getDefaultCookieValue] = t1;
        Cookies.set(cookieName, getDefaultCookieValue(nextPersona), {
          expires: LONG_LASTING_COOKIE_EXPIRATION
        });
      });
      setPersona(nextPersona);
      router.refresh();
    };
    $[0] = router;
    $[1] = setPersona;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const setPersistedPersona = t0;
  let t1;
  if ($[3] !== persona || $[4] !== setPersistedPersona) {
    t1 = function togglePersona() {
      const nextPersona_0 = persona === PERSONAS.collector ? PERSONAS.advanced : PERSONAS.collector;
      setPersistedPersona(nextPersona_0);
    };
    $[3] = persona;
    $[4] = setPersistedPersona;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const togglePersona = t1;
  let t2;
  if ($[6] !== persona || $[7] !== setPersistedPersona || $[8] !== togglePersona) {
    t2 = {
      persona,
      setPersona: setPersistedPersona,
      togglePersona
    };
    $[6] = persona;
    $[7] = setPersistedPersona;
    $[8] = togglePersona;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}